import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import { PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts.js';
import WearableIconCustom from '../../CustomIcons/WearableIconCustom.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import CustomField from '../Fields/CustomField.jsx';

const convertMsToSeconds = (ms) => {
  if (!ms && ms !== 0) return '';
  return Math.round(ms / 1000);
};

const convertSecondsToMs = (seconds) => {
  if (!seconds && seconds !== 0) return null;
  return parseInt(seconds, 10) * 1000;
};

const validate = (values) => {
  const errors = {};
  
  if (values.wearableEmergencyIdleTime && values.wearableEmergencyIdleTime < 0) {
    errors.wearableEmergencyIdleTime = 'valueMustBePositive';
  }
  
  if (values.wearableDataIdleTime && values.wearableDataIdleTime < 0) {
    errors.wearableDataIdleTime = 'valueMustBePositive';
  }
  
  if (values.wearableAccelerometerDataIdleTime && values.wearableAccelerometerDataIdleTime < 0) {
    errors.wearableAccelerometerDataIdleTime = 'valueMustBePositive';
  }
  
  if (values.wearableDataRssiThreshold && (values.wearableDataRssiThreshold < -100 || values.wearableDataRssiThreshold > 0)) {
    errors.wearableDataRssiThreshold = 'rssiValueMustBeBetweenMinus100And0';
  }
  
  return errors;
};

@reduxForm({ 
  form: 'WearableSettingsForm', 
  validate,
})
class WearableSettingsForm extends React.Component {
  render() {
    const canEditSettings = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.UPDATE], PERMISSION_ENTITIES.COMPANY);
    
    return (
      <div>
        <FormFlatContainer
          title="wearableSettingsTitle"
          subtitle="wearableSettingsDescription"
          icon={<WearableIconCustom style={{ width: 22 }} />}
          containerStyle={{ marginRight: 10, marginTop: 0 }}
        >
          <Form>
            <input style={{ display: 'none' }} type="username" name="username" />
            
            <Entity
              componentClass={Field}
              type="number"
              name="wearableEmergencyIdleTime"
              componentAttribute="placeholder"
              entity="insertWearableEmergencyIdleTime"
              title={<Entity entity="wearableEmergencyIdleTime" />}
              helpText={<Entity entity="wearableEmergencyIdleTimeDescription" />}
              component={CustomField}
              disabled={!canEditSettings}
              textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
            />
            
            <Entity
              componentClass={Field}
              type="number"
              name="wearableDataIdleTime"
              componentAttribute="placeholder"
              entity="insertWearableDataIdleTime"
              title={<Entity entity="wearableDataIdleTime" />}
              helpText={<Entity entity="wearableDataIdleTimeDescription" />}
              component={CustomField}
              disabled={!canEditSettings}
              textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
            />
            
            <Entity
              componentClass={Field}
              type="number"
              name="wearableAccelerometerDataIdleTime"
              componentAttribute="placeholder"
              entity="insertWearableAccelerometerDataIdleTime"
              title={<Entity entity="wearableAccelerometerDataIdleTime" />}
              helpText={<Entity entity="wearableAccelerometerDataIdleTimeDescription" />}
              component={CustomField}
              disabled={!canEditSettings}
              textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
            />
            
            <Entity
              componentClass={Field}
              type="number"
              name="wearableDataRssiThreshold"
              componentAttribute="placeholder"
              entity="insertWearableDataRssiThreshold"
              title={<Entity entity="wearableDataRssiThreshold" />}
              helpText={<Entity entity="wearableDataRssiThresholdDescription" />}
              component={CustomField}
              disabled={!canEditSettings}
              textFormattingFunction={value => value.replace(/[\s.]+/g, '')}
            />
          </Form>
        </FormFlatContainer>
      </div>
    );
  }
}

export default WearableSettingsForm;

export { convertMsToSeconds, convertSecondsToMs };
